// 3rd Party
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// dnd
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  rectSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Components
import CategoryFormDialog from "./CategoryFormDialog";
import Spinner from "../../components/spinner/Spinner";

// Services
import {
  CategoryEntry,
  createDefaultCategoryEntry,
  defaultCategoryEntry,
  prepareCategoryEntryForEdit,
} from "../../services/categoryEntryService";
import { logout } from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";
import { syncExtraCategoriesToBlob } from "../../services/ExtraCategoriesSyncService";

// Config
import { appConfig } from "../../config/appConfig";

// AssetComponents
import edit from "../../assets/edit.svg";
import approve from "../../assets/approve.svg";
import add from "../../assets/add.svg";

// Styles
import "./Categorymain.scss";

syncExtraCategoriesToBlob();

const Categorymain = () => {
  // useState
  const [dataList, setDataList] = useState<CategoryEntry[]>([]);
  const [filterList, setFilterList] = useState<CategoryEntry[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<CategoryEntry>(defaultCategoryEntry);
  const [page, setPage] = useState(0);
  const rowsPerPage = 12;

  // useNavigate
  const navigate = useNavigate();

  // useEffect (Load from localStorage)
  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: CategoryEntry[] = JSON.parse(savedData);
      setDataList(parsedData);
      setFilterList(parsedData);

      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  // useEffect (Initial data fetch)
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    console.log("dataList new1");
    console.log(dataList);
  }, [dataList]);

  // useEffect (When editingIndex changes)
  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const icon =
          typeof selectedEntry.icon === "string"
            ? selectedEntry.icon.split(",")
            : Array.isArray(selectedEntry.icon)
              ? selectedEntry.icon
              : [];

        const videoUrls =
          typeof selectedEntry.videoUrls === "string"
            ? selectedEntry.videoUrls.split(",")
            : Array.isArray(selectedEntry.videoUrls)
              ? selectedEntry.videoUrls
              : [];

        setFormData({
          ...selectedEntry,
          icon,
          videoUrls,
        });
      }
    }
  }, [editingIndex, dataList]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(appConfig.serviceUrls.saveCategory, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }

      if (!response.ok) throw new Error("Failed to fetch data");
      const data: CategoryEntry[] = await response.json();
      // setDataList(data || []);
      // setFilterList(data || []);
      // sort by priority (ascending)
      const sortedData = (data || []).sort(
        (a, b) => (a.priority ?? 0) - (b.priority ?? 0),
      );

      setDataList(sortedData);
      setFilterList(sortedData);
      syncExtraCategoriesToBlob();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData(createDefaultCategoryEntry(dataList.length + 1)); // auto-increment ID
    setEditingIndex(null);
  };
  // Add New Record
  // {/* ***do not delete */}
  const handleAdd = () => {
    setEditingIndex(null);
    setShowForm(true);
    setFormData({
      ...createDefaultCategoryEntry(0), // Initialize with id 0
      priority: dataList.length + 1,
    });
  };

  const handleEdit = (index: number) => {
    if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
      console.error("Error: dataList is empty");
      return;
    }

    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      console.error("No entry found at index:", index);
      return;
    }

    const formattedEntry = prepareCategoryEntryForEdit(selectedEntry);

    setFormData(formattedEntry);

    setEditingIndex(selectedEntry.id);
    setShowForm(true);
  };

  const handlePublish = async (index: number) => {
    const selectedEntry = dataList.find((item) => item.id === index);
    if (!selectedEntry) {
      alert("Invalid entry .");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedEntry.id.toString());
    formDataToSend.append("name", selectedEntry.name);
    formDataToSend.append("priority", selectedEntry.priority.toString());

    formDataToSend.append("isActive", selectedEntry.isActive.toString());
    formDataToSend.append("status", "Published");
    formDataToSend.append("uploadBy", selectedEntry.uploadBy);
    formDataToSend.append("statusCode", "3");

    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("publishBy", username);
    formDataToSend.append("icon", selectedEntry.icon.toString());
    formDataToSend.append("pinIcon", selectedEntry.pinIcon.toString());

    setLoading(true);
    const url = `${appConfig.serviceUrls.saveCategory}/${selectedEntry.id}`;

    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(url, {
        method: "PUT",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }

      if (!response.ok) throw new Error("Failed to save data");

      // fetchData();
      // resetForm();
      // setEditingIndex(null);
    } catch (error) {
      console.error("Error saving data:", error);
      console.error("Backend error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlednd = async () => {
    if (!window.confirm("Are you sure you want to save this entry?")) return;
    const updatedList = dataList.map((item, index) => ({
      ...item,
    }));

    for (const item of updatedList) {
      await handlePublish(item.id);
    }

    alert("Entry save successfully.");
  };

  // {/* ***do not delete */}
  // const handleDelete = async (id: number) => {
  //   if (!window.confirm("Are you sure want to delete this entry?")) return;
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/${id}`, {
  //       method: "DELETE",
  //     });

  //     if (!response.ok) throw new Error("Failed to delete");

  //     fetchData();
  //     if (editingIndex !== null && dataList[editingIndex]?.id === id) {
  //       setEditingIndex(null);
  //     }
  //   } catch (error) {
  //     console.error("Error saving data:", error);
  //   }
  // };

  // dnd
  // 🔹 Sortable Item Component

  // 🔹 Sortable Item Component

  // 👇 before return
  const firstItem = dataList[0];

  let iconSrc = "";
  if (firstItem) {
    if (typeof firstItem.icon === "string") {
      iconSrc = firstItem.icon.split(",")[0].trim();
    } else if (Array.isArray(firstItem.icon)) {
      iconSrc = firstItem.icon[0];
    }
  }

  const SortableItem = ({ item }: any) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id: item.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    let iconSrc = "";
    if (typeof item.icon === "string") {
      iconSrc = item.icon.split(",")[0].trim();
    } else if (Array.isArray(item.icon)) {
      iconSrc = item.icon[0];
    }

    return (
      <Paper
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        sx={{
          padding: 2,
          textAlign: "center",
          cursor: "grab",
        }}
      >
        {/* Image / Placeholder */}
        {iconSrc ? (
          <img src={iconSrc} alt="icon" width="60" height="60" />
        ) : (
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#eee",
              margin: "0 auto",
            }}
          />
        )}

        {/* Name */}
        <Typography mt={1}>{item.name || "No Name"}</Typography>
      </Paper>
    );
  };
  return (
    <Box className="container-wraper">
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography className="bold-header-text">
            <b>Category</b>{" "}
          </Typography>
          {/* do not delete */}
          <Button
            onClick={handleAdd}
            size="small"
            className="custom-button"
            sx={{ display: "none" }}
          >
            <img
              loading="lazy"
              src={add}
              alt="visiable"
              className="img-style"
            />{" "}
            <Typography className="btn-text">Add</Typography>
          </Button>
        </Box>
      </>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
        {loading ? (
          <>
            {" "}
            <Spinner></Spinner>
          </>
        ) : (
          <></>
        )}
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
          }}
        >
          {dataList?.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow className="custom-table-head-row">
                  {/* <TableCell><b>ID</b></TableCell> */}
                  <TableCell className="nowrap">
                    <b>Category Name</b>
                  </TableCell>
                  {/* <TableCell className="nowrap">
                    <b>prority</b>
                  </TableCell> */}

                  <TableCell>
                    <b>Menu Icon</b>
                  </TableCell>
                  <TableCell>
                    <b>Map Pin</b>
                  </TableCell>

                  <TableCell>
                    <b>Active / Disable</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                  <TableCell>
                    <b>Actions</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataList
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.name || "\u00A0"}</TableCell>
                      {/* <TableCell>{item.priority || "\u00A0"}</TableCell> */}

                      <TableCell>
                        {typeof item.icon === "string" &&
                        item.icon.trim() !== "" ? (
                          item.icon.split(",").map((img, index) => (
                            <div key={index}>
                              <img
                                loading="lazy"
                                key={index}
                                src={img}
                                alt="Uploaded"
                                width="40"
                                height="50"
                              />
                            </div>
                          ))
                        ) : (
                          <Typography>No icon</Typography>
                        )}
                      </TableCell>

                      <TableCell>
                        {typeof item.pinIcon === "string" &&
                        item.pinIcon.trim() !== "" ? (
                          item.pinIcon.split(",").map((img, index) => (
                            <Box
                              key={index}
                              component="span"
                              sx={{ display: "inline-block", mr: 1 }}
                            >
                              <img
                                src={img.trim()}
                                alt={`Icon ${index + 1}`}
                                width={40}
                                height={50}
                                loading="lazy"
                              />
                            </Box>
                          ))
                        ) : (
                          <Typography>No Pin icon</Typography>
                        )}
                      </TableCell>

                      <TableCell>
                        {item.isActive ? "Active" : "Disable"}
                      </TableCell>

                      {item.status === "Approved" ? (
                        <TableCell className="approved-text">
                          {item.status}
                        </TableCell>
                      ) : item.status === "Published" ? (
                        <TableCell className="approved-text">
                          {item.status}
                        </TableCell>
                      ) : item.status === "Pending" ? (
                        <TableCell className="pending-txt">
                          {item.status}
                        </TableCell>
                      ) : (
                        <TableCell className="publish-txt">
                          {item.status}
                        </TableCell>
                      )}
                      <TableCell
                        align="left"
                        className="nowrap sticky-right-top"
                      >
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => {
                            handleEdit(page * rowsPerPage + index);
                          }}
                        >
                          <img
                            loading="lazy"
                            src={edit}
                            alt="visiable"
                            className="img-style"
                          />
                        </IconButton>
                        {/* **** do not delete */}
                        {/* <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleDelete(item.id)}
                        >
                          <img
                            loading="lazy"
                            src={delete1}
                            alt="visiable"
                            className="img-style"
                           
                          />
                        </IconButton> */}

                        {item.status === "Approved" && (
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => handlePublish(item.id)}
                          >
                            <img
                              src={approve}
                              alt="visiable"
                              className="img-style"
                            />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <Box
              textAlign="center"
              mt={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              <Typography align="center" sx={{ mt: 2 }}>
                No records found.
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "1rem",

              bottom: 0,

              zIndex: 1,

              overflowX: "hidden",
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "normal",
              }}
            >
              Showing {page * rowsPerPage + 1} to{" "}
              {Math.min(dataList.length, page * rowsPerPage + rowsPerPage)} of{" "}
              {dataList.length} entries
            </Typography>
            <Pagination
              count={Math.ceil(dataList.length / rowsPerPage)}
              page={page + 1}
              onChange={(e, value) => setPage(value - 1)}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </TableContainer>
      </Box>
      {/* drag nd drop */}

      <Box sx={{ width: "100%", mt: 2 }}>
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography className="bold-header-text">
              <b>Rearrange Component</b>{" "}
            </Typography>

            <Button onClick={handlednd} size="small" className="custom-button">
              <Typography className="btn-text">Save</Typography>
            </Button>
          </Box>
        </>

        <DndContext
          collisionDetection={closestCenter}
          // onDragEnd={(event: any) => {
          //   const { active, over } = event;

          //   if (!over) return;

          //   const oldIndex = dataList.findIndex((i) => i.id === active.id);
          //   const newIndex = dataList.findIndex((i) => i.id === over.id);

          //   //  Prevent moving to index 0
          //   if (newIndex === 0) return;

          //   if (oldIndex !== newIndex) {
          //     const updated = arrayMove(dataList, oldIndex, newIndex);

          //     // Ensure first item stays fixed
          //     const firstItem = dataList[0];
          //     updated[0] = firstItem;

          //     setDataList(updated);
          //   }
          // }}
          onDragEnd={(event: any) => {
            const { active, over } = event;

            if (!over) return;

            const oldIndex = dataList.findIndex((i) => i.id === active.id);
            const newIndex = dataList.findIndex((i) => i.id === over.id);

            // Prevent moving to index 0
            if (newIndex === 0) return;

            if (oldIndex !== newIndex) {
              let updated = arrayMove(dataList, oldIndex, newIndex);

              // Keep first item fixed
              const firstItem = dataList[0];
              updated[0] = firstItem;

              //  Reassign priority based on new order
              updated = updated.map((item, index) => ({
                ...item,
                priority: index + 1, // 1-based priority
              }));

              setDataList(updated);
            }
          }}
        >
          <SortableContext
            items={dataList.map((item) => item.id)}
            strategy={rectSortingStrategy}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: 2,
              }}
            >
              {/* non- Draggable items */}
              {firstItem && (
                <Paper
                  sx={{
                    padding: 2,
                    textAlign: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  {iconSrc ? (
                    <img src={iconSrc} alt="icon" width="60" height="60" />
                  ) : (
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        backgroundColor: "#eee",
                        margin: "0 auto",
                      }}
                    />
                  )}

                  <Typography mt={1}>{firstItem.name}</Typography>
                </Paper>
              )}

              {/*  Draggable items */}
              {dataList
                .slice(1) // 👈 important
                .map((item) => (
                  <SortableItem key={item.id} item={item} />
                ))}
            </Box>
          </SortableContext>
        </DndContext>
      </Box>
      <CategoryFormDialog
        open={showForm}
        onClose={() => setShowForm(false)}
        fetchData={fetchData}
        resetForm={resetForm}
        formData={formData}
        setFormData={setFormData}
        editingIndex={editingIndex}
        setEditingIndex={setEditingIndex}
        setShowForm={setShowForm}
        dataList={dataList}
      />
    </Box>
  );
};

export default Categorymain;
